import { HttpStatusCode } from 'axios';

import { isInvalidAccessToken } from '@/lib/invalid-access-token';

const MAX_SERVER_ERROR_RETRIES = 3;
const MAX_DEFAULT_RETRIES = 1;

type QueryError = { response?: { status?: number; data?: unknown } } | null;

export const shouldRetryQuery = (failureCount: number, error: unknown): boolean => {
  const response = (error as QueryError)?.response;
  const status = response?.status;
  if (status === HttpStatusCode.Forbidden) return false;
  if (isInvalidAccessToken(status, response?.data)) return false;
  if (status !== undefined && status >= HttpStatusCode.InternalServerError) {
    return failureCount < MAX_SERVER_ERROR_RETRIES;
  }
  return failureCount < MAX_DEFAULT_RETRIES;
};
